/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { CreateTimeEntryRequestAppointmentId } from './CreateTimeEntryRequestAppointmentId';
import {
    CreateTimeEntryRequestAppointmentIdFromJSON,
    CreateTimeEntryRequestAppointmentIdFromJSONTyped,
    CreateTimeEntryRequestAppointmentIdToJSON,
    CreateTimeEntryRequestAppointmentIdToJSONTyped,
} from './CreateTimeEntryRequestAppointmentId';
import type { MakeupStatus } from './MakeupStatus';
import {
    MakeupStatusFromJSON,
    MakeupStatusFromJSONTyped,
    MakeupStatusToJSON,
    MakeupStatusToJSONTyped,
} from './MakeupStatus';

/**
 * 
 * @export
 * @interface MakeupScrollFilterRequest
 */
export interface MakeupScrollFilterRequest {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof MakeupScrollFilterRequest
     */
    memberId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof MakeupScrollFilterRequest
     */
    studentId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof MakeupScrollFilterRequest
     */
    teacherId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof MakeupScrollFilterRequest
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof MakeupScrollFilterRequest
     */
    sourceClassId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof MakeupScrollFilterRequest
     */
    makeupClassId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {CreateTimeEntryRequestAppointmentId}
     * @memberof MakeupScrollFilterRequest
     */
    sourceAppointmentId: CreateTimeEntryRequestAppointmentId | null;
    /**
     * 
     * @type {CreateTimeEntryRequestAppointmentId}
     * @memberof MakeupScrollFilterRequest
     */
    makeupAppointmentId: CreateTimeEntryRequestAppointmentId | null;
    /**
     * 
     * @type {MakeupStatus}
     * @memberof MakeupScrollFilterRequest
     */
    status: MakeupStatus | null;
    /**
     * 
     * @type {any}
     * @memberof MakeupScrollFilterRequest
     */
    fromDate: any | null;
    /**
     * 
     * @type {any}
     * @memberof MakeupScrollFilterRequest
     */
    toDate: any | null;
}



/**
 * Check if a given object implements the MakeupScrollFilterRequest interface.
 */
export function instanceOfMakeupScrollFilterRequest(value: object): value is MakeupScrollFilterRequest {
    if (!('memberId' in value) || value['memberId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('sourceClassId' in value) || value['sourceClassId'] === undefined) return false;
    if (!('makeupClassId' in value) || value['makeupClassId'] === undefined) return false;
    if (!('sourceAppointmentId' in value) || value['sourceAppointmentId'] === undefined) return false;
    if (!('makeupAppointmentId' in value) || value['makeupAppointmentId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('fromDate' in value) || value['fromDate'] === undefined) return false;
    if (!('toDate' in value) || value['toDate'] === undefined) return false;
    return true;
}

export function MakeupScrollFilterRequestFromJSON(json: any): MakeupScrollFilterRequest {
    return MakeupScrollFilterRequestFromJSONTyped(json, false);
}

export function MakeupScrollFilterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MakeupScrollFilterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'memberId': ActorActivityRecordActorUserIdFromJSON(json['memberId']),
        'studentId': ActorActivityRecordActorUserIdFromJSON(json['studentId']),
        'teacherId': ActorActivityRecordActorUserIdFromJSON(json['teacherId']),
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'sourceClassId': ActorActivityRecordActorUserIdFromJSON(json['sourceClassId']),
        'makeupClassId': ActorActivityRecordActorUserIdFromJSON(json['makeupClassId']),
        'sourceAppointmentId': CreateTimeEntryRequestAppointmentIdFromJSON(json['sourceAppointmentId']),
        'makeupAppointmentId': CreateTimeEntryRequestAppointmentIdFromJSON(json['makeupAppointmentId']),
        'status': MakeupStatusFromJSON(json['status']),
        'fromDate': json['fromDate'],
        'toDate': json['toDate'],
    };
}

export function MakeupScrollFilterRequestToJSON(json: any): MakeupScrollFilterRequest {
    return MakeupScrollFilterRequestToJSONTyped(json, false);
}

export function MakeupScrollFilterRequestToJSONTyped(value?: MakeupScrollFilterRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'memberId': ActorActivityRecordActorUserIdToJSON(value['memberId']),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
        'teacherId': ActorActivityRecordActorUserIdToJSON(value['teacherId']),
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'sourceClassId': ActorActivityRecordActorUserIdToJSON(value['sourceClassId']),
        'makeupClassId': ActorActivityRecordActorUserIdToJSON(value['makeupClassId']),
        'sourceAppointmentId': CreateTimeEntryRequestAppointmentIdToJSON(value['sourceAppointmentId']),
        'makeupAppointmentId': CreateTimeEntryRequestAppointmentIdToJSON(value['makeupAppointmentId']),
        'status': MakeupStatusToJSON(value['status']),
        'fromDate': value['fromDate'],
        'toDate': value['toDate'],
    };
}

